import { animated, useSpring } from '@react-spring/web';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import { UnfinishedRoutesIcon } from '../../../../assets/svg/home-notifications/UnfinishedRoutesIcon';
import * as routing from '../../../../constants/Routing';
import { useSearchLastUnfinishedRoute } from '../hooks/useSearchLastUnfinishedRoute';
import { NotificationPill } from './notification-pill';

interface ActiveRouteNotificationProps {
  refreshTrigger: number;
}

export const ActiveRouteNotification = ({ refreshTrigger }: ActiveRouteNotificationProps) => {
  const navigate = useNavigate();
  const { data: lastUnfinishedRoute, run: searchLastUnfinishedRoute } = useSearchLastUnfinishedRoute();

  //Animations
  const enterAnimationHeight = useSpring({
    height: lastUnfinishedRoute ? 85 : 0,
  });
  const enterAnimationOpacity = useSpring({
    opacity: lastUnfinishedRoute ? 1 : 0,
    delay: 125,
  });

  useEffect(() => {
    searchLastUnfinishedRoute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTrigger]);

  if (!lastUnfinishedRoute) {
    return null;
  }

  return (
    <animated.div style={{ padding: `0px 24px`, ...enterAnimationHeight, ...enterAnimationOpacity }}>
      <NotificationPill
        notification={{
          icon: <UnfinishedRoutesIcon />,
          titleIntlId: `drivers.home_notification.active_route.title`,
          messageIntlId: `drivers.home_notification.active_route.message`,
          messageIntlValues: { route_label: lastUnfinishedRoute.plan_label ?? `` },
          onClick: () => {
            navigate(routing.PRIVATE_ROUTES.ROUTE_DETAILS.replace(`:routeId`, lastUnfinishedRoute.id));
          },
          hasRightArrow: true,
        }}
        containerStyles={{ backgroundColor: `#FFFCF4` }}
        titleStyles={{ color: `#E99E03` }}
        messageStyles={{ color: RoutalPalette.neutral40 }}
        arrowStyles={{ color: `#E99E03` }}
      />
    </animated.div>
  );
};
